import React, { useState, useEffect } from "react";
import BecomeAMember from "../../components/BecomeAMember";
import BecomeAMemberSummary from "../../components/BecomeAMemberSummary";
import PropTypes from "prop-types";
import { canUseDOM, isBizNull } from "../../utils/dom";
import api from "../../utils/api";
import { MathUtils } from "../../utils";
import { isEmptyObj } from "../../utils/siteUtils";
import { S_ORDER_ID, webStorage } from "../../utils/webStorage";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { becomeAMemberSummary, clearCalculationPrice, clearComparisonToolApiBody, setShowChangeMembershipModels } from "../../redux/actions/becomeAMember";
import { selectComparisonToolApiBody, selectUserState } from "../../selectors/application";
import MembershipModal from "./../MembershipModal";
import useQuery from "../../utils/useQuery";
import { scrollToSmoothTryMultipleTimes } from "../../hooks/scrollToSmooth.js";
import { creatingClues } from "../../utils/comparisonTool";
import { getMembershipLevel } from "../../utils/measurements";
import { accountAddInfo } from "../../services/caseInfo";

const BecomeAMemberFlow = props => {
  const { fields, lang, user, calculationPrice, setBecomeAMemberSummary, clearCalculationPrice, comparisonToolApiBody, clearComparisonToolApiBody, history, match, setShowChangeMembershipModels, showModels, page } = props;

  const langLower = lang.toLowerCase();
  let calculationRoute = isEmptyObj(calculationPrice) ? false : calculationPrice,
    urlHash = canUseDOM() && window.location.hash ? window.location.hash.replace("#", "") : "",
    query = useQuery(),
    urlHashMember = false,
    unloadStatus = false;
  if (calculationRoute && calculationRoute.membership && !urlHash) {
    urlHash = calculationRoute.membership;
  }

  const comparisonString = (itemA, itemB) => {
    return itemA?.toLowerCase() === itemB?.toLowerCase();
  };
  const becomeAMemberData = fields => {
    const { backgroundImage, headingBody, headingType, body, levels, defaultSelectLevel, loadMoreItem, redirectUrlAfterLogout, logoutButtonText, continueButton } = fields;
    let becomeAMember = {},
      membershipOptions = [],
      children = [],
      membershipAccordion = {},
      currentLevel = 0,
      defaultSelectLevelIndex = null;
    // currency deposit country cta
    if (levels) {
      membershipOptions = levels.map((levelItem, index) => {
        let { level, backgroundImage, carConfigItems, scrollTo } = levelItem.fields;
        let levelValue = level?.fields?.phrase?.value || "",
          membershipOptionsSummary = levelItem.fields.summary?.fields || "";
        if (comparisonString(levelValue, urlHash)) {
          currentLevel = index;
          urlHashMember = true;
        }
        if (defaultSelectLevel && levelItem.id === defaultSelectLevel.id) {
          defaultSelectLevelIndex = index;
        }
        let {
          summary,
          heroheadingBody,
          heroheadingType,
          infoheadingBody,
          infoheadingType,
          infoBody,
          buttonText,
          icon,
          iconLink,
          errorMessageText,
          systemErrorMessageText,
          loginForm,
          inStoreLoginForm,
          showLoginForm,
          createAccountHeadingType,
          createAccountHeadingBody,
          createAccountButton,
          preSalesLoginUrl,
          nextPageUrl
        } = membershipOptionsSummary;
        membershipOptionsSummary.id = levelItem.fields.summary?.id;
        let membershipOptionsSummaryBackground = { value: { src: "" } };
        if (membershipOptionsSummary?.backgroundImage.value.src) {
          membershipOptionsSummaryBackground = membershipOptionsSummary.backgroundImage;
        }
        let sharedSummaryDataSummary = summary[0] ? summary[0].fields : {};
        let { headingBody, headingType, body, membershipSectionName, countryLabel, currentCountries, membership, carselectionName, colorLabel, engineLabel, topaynowSectionName, preorderdeposit, preorderdepositValue, price, disclaimer } = sharedSummaryDataSummary;
        let createAccountButtonValue = createAccountButton && JSON.parse(JSON.stringify(createAccountButton));
        let newUrl = nextPageUrl ? nextPageUrl.value.href : "";
        if (createAccountButtonValue?.fields.link?.value.href && newUrl) {
          createAccountButtonValue.fields.link.value.href += `?redirect=${encodeURIComponent(newUrl)}`;
        }
        let itemSummary = {
          id: levelItem.fields.summary?.id,
          errorMessageText: errorMessageText,
          systemErrorMessageText: systemErrorMessageText,
          preorderdepositValue: preorderdepositValue ? preorderdepositValue.value : "0",
          hero: {
            backgroundImage: membershipOptionsSummaryBackground,
            heroHeadingType: heroheadingType || {
              fields: { phrase: { value: "h1" } }
            },
            heroHeadingBody: heroheadingBody
          },
          info: {
            heading: {
              html: infoheadingBody,
              type: infoheadingType || {
                fields: { phrase: { value: "h2" } }
              }
            },
            body: infoBody?.value || "",
            cta: {
              buttonText: buttonText?.value || "",
              width: "auto",
              iconName: icon,
              link: iconLink?.value?.href ? iconLink : ""
            },
            error: ""
          },
          summary: {
            showSummary: !isEmptyObj(sharedSummaryDataSummary),
            text: {
              heading: {
                type: headingType || {
                  fields: { phrase: { value: "h3" } }
                },
                html: headingBody
              },
              body: body?.value || ""
            },
            details: {
              membership: {
                heading: {
                  type: { fields: { phrase: { value: "" } } },
                  html: {
                    value: `<span class="sub-heading">${membershipSectionName?.value || ""}</span>`
                  }
                },
                country: {
                  label: countryLabel?.value || "",
                  value:
                    currentCountries?.fields.items.filter((item, index) => {
                      let cuy = lang.indexOf("-") > -1 ? lang.split("-")[1] : "";
                      return cuy.toLowerCase() === item?.fields?.phrase.value.toLowerCase();
                    })[0]?.fields.key.value || ""
                },
                membership: {
                  label: membership?.value || ""
                }
              },
              selection: {
                heading: {
                  type: { fields: { phrase: { value: "" } } },
                  html: {
                    value: `<span class="sub-heading">${carselectionName?.value || ""}</span>`
                  }
                },
                choices: {
                  color: {
                    label: colorLabel?.value || ""
                  },
                  engine: {
                    label: engineLabel?.value || ""
                  }
                }
              },
              deposit: {
                heading: {
                  type: { fields: { phrase: { value: "" } } },
                  html: {
                    value: `<span class="sub-heading">${topaynowSectionName?.value || ""}</span>`
                  }
                },
                deposit: {
                  value: "0",
                  label: preorderdeposit?.value || ""
                },
                disclaimer: {
                  body: disclaimer?.value || ""
                },
                currency: ""
              },
              price: {
                value: "0",
                label: price?.value || ""
              },
              login: {
                showLoginForm: showLoginForm,
                createAccountHeadingType: createAccountHeadingType,
                createAccountHeadingBody: createAccountHeadingBody,
                createAccountButton: createAccountButtonValue,
                loginForm: loginForm[0],
                inStoreLoginForm: inStoreLoginForm[0],
                lang: props.lang,
                history: props.history,
                defaultRedirect: props.defaultRedirect,
                user: props.user,
                preSalesLoginUrl: preSalesLoginUrl,
                nextPageUrl: nextPageUrl,
                redirectUrlAfterLogout: redirectUrlAfterLogout,
                logoutButtonText: logoutButtonText,
                cta: {
                  buttonText: user ? continueButton?.fields.buttonText.value + " " + user.firstName : "",
                  width: "auto",
                  iconName: continueButton?.fields.iconName
                }
              }
            }
          }
        };
        let option = {
          topText: "",
          text: "",
          label: levelValue,
          value: "",
          backgroundImage: backgroundImage.value.src ? backgroundImage.value : { src: "" },
          summaryData: itemSummary,
          carConfigItems: carConfigItems,
          scrollToId: scrollTo?.id
        };
        return option;
      });
    }
    if (loadMoreItem) {
      membershipAccordion = {
        heading: {
          html: loadMoreItem.fields.closeheadingBody,
          type: loadMoreItem.fields.closeheadingType || {
            type: { fields: { phrase: { value: "h2" } } }
          }
        },
        headingOpen: {
          html: loadMoreItem.fields.openheadingBody,
          type: loadMoreItem.fields.openheadingType || {
            type: { fields: { phrase: { value: "h2" } } }
          }
        },
        open: loadMoreItem.fields.open.value || false
      };
      children = loadMoreItem.fields.options;
    }
    becomeAMember = {
      heading: {
        type: headingType ? headingType : { type: { fields: { phrase: { value: "h1" } } } },
        html: headingBody
      },
      body,
      backgroundImage: backgroundImage?.value?.src || "",
      options: membershipOptions,
      accordion: membershipAccordion,
      children: children,
      apiList: false
    };
    if (defaultSelectLevelIndex !== null) {
      becomeAMember.preselectedIndex = defaultSelectLevelIndex;
    }
    if (urlHash && urlHashMember) {
      becomeAMember.preselectedIndex = currentLevel;
    }
    return becomeAMember;
  };

  const [membership, setMembership] = useState(becomeAMemberData(fields));
  const [sharedSummaryData, setSharedSummaryData] = useState(() => {
    let index = membership.preselectedIndex ? membership.preselectedIndex : 0;
    return membership.options[index].summaryData;
  });

  const [showSumamry, setShowSummary] = useState(false);
  const [showFollowUpQuestions, setShowFollowUpQuestions] = useState(false);
  const [followUpQuestions, setFollowUpQuestions] = useState([]);
  const [selectedMembership, setSelectedMembership] = useState(() => {
    let index = membership.preselectedIndex ? membership.preselectedIndex : 0;
    return membership.options[index];
  });
  const [selectedEngine, setSelectedEngine] = useState();
  const [selectedColor, setSelectedColor] = useState();
  const [selectedFinancing, setSelectedFinancing] = useState();
  const [selectedState, setSelectedState] = useState(false);
  const [engine, setEngine] = useState({});
  const [color, setColor] = useState({});
  const [financing, setFinancing] = useState({});
  const [shopspuId, setShopspuId] = useState(0);
  const [localCash, setLocalCash] = useState();
  const [country] = useState(lang.indexOf("-") > -1 ? lang.split("-")[1] : "se");

  useEffect(() => {
    //** Measurements */
    let dataLayer = window.dataLayer || [];
    let _currency = "EUR";
    if (country === "se") {
      _currency = "SEK";
    }
    let _page = {
      type: page.fields.pageType,
      currency: _currency,
      country: lang
    };
    dataLayer.push({
      event: "virtualPageview",
      virtualPageUrl: history.location.pathname + history.location.search,
      virtualPageTitle: "pre_sales_become_a_member",
      page: _page
    });

    getDate();
    return () => {
      unloadStatus = true;
    };
  }, []);

  useEffect(() => {
    let body = {
        spuId: shopspuId
      },
      searchParams = "",
      skuAttributeValueMap = {};
    if (localCash && urlHash.toUpperCase() === "MEMBERSHIP04") {
      skuAttributeValueMap[localCash.apiParentLabel] = localCash.value;
      setSelectedFinancing(localCash);
    }
    if (selectedColor) {
      skuAttributeValueMap[selectedColor.apiParentLabel] = selectedColor.value;
    }
    if (selectedEngine) {
      skuAttributeValueMap[selectedEngine.apiParentLabel] = selectedEngine.value;
    }
    if (selectedFinancing && selectedFinancing.apiParentLabel) {
      skuAttributeValueMap[selectedFinancing.apiParentLabel] = selectedFinancing.value;
    }
    let urlSearchArr = Object.keys(skuAttributeValueMap);
    urlSearchArr.forEach((item, index) => {
      if (index === 0) {
        searchParams += `?${item}=${skuAttributeValueMap[item]}`;
      } else {
        searchParams += `&${item}=${skuAttributeValueMap[item]}`;
      }
    });

    if (selectedColor || selectedEngine || selectedFinancing) {
      body = {
        ...body,
        skuAttributeValueMap: {
          ...skuAttributeValueMap
        }
      };
    }
    if (shopspuId && (selectedColor || selectedEngine || selectedFinancing?.value)) {
      getdetail({ ...body });
      let newUrl = window.location.origin + window.location.pathname + searchParams + window.location.hash;
      window.history.pushState(null, null, newUrl);
    }
  }, [selectedState]);

  useEffect(() => {
    let index = membership.options.findIndex(option => option.value === shopspuId);
    index = index === -1 ? 0 : index;
    setSharedSummaryData(membership.options[index].summaryData);
  }, [shopspuId]);

  if (!props) return;
  const getDate = async () => {
    if (!membership.apiList) {
      let res = await getList();
      res.forEach(resItem => {
        membership.options.map(memberOptionsItem => {
          if (comparisonString(memberOptionsItem.label, resItem.membershipCode) && resItem.spuList.length) {
            memberOptionsItem.text = resItem.membershipName;
            memberOptionsItem.value = resItem.spuList[0].id;
            let optionConfigItems = handleConfigItems(memberOptionsItem);
            let skuAttributeListValue = resItem.spuList[0].skuAttributeList ? resItem.spuList[0].skuAttributeList : [];
            let siteHaveFinance = optionConfigItems.length ? optionConfigItems.filter(item => item.code === "finance").length : false;
            let apiHaveFinance = skuAttributeListValue.length ? skuAttributeListValue.filter(item => item.defaultLanguageLabel.toLowerCase() === "finance").length : false;
            let apiCash = null;
            skuAttributeListValue.forEach(item => {
              if (!siteHaveFinance && apiHaveFinance && item.defaultLanguageLabel.toLowerCase() === "finance") {
                apiCash = item.spuSkuAttibuteValueList.filter(spuSkuAttibuteValueItem => spuSkuAttibuteValueItem.defaultLanguageValue.toLowerCase() === "cash");
                if (apiCash.length) {
                  apiCash = apiCash[0];
                  apiCash.apiParentCode = item.defaultLanguageLabel.toLowerCase();
                  apiCash.apiParentLabel = item.lable.toLowerCase();
                } else {
                  apiCash = null;
                }
              }
              optionConfigItems.forEach((optionsItem, index) => {
                if (comparisonString(optionsItem.code, item.defaultLanguageLabel)) {
                  let itemOptions = item.spuSkuAttibuteValueList.map((listItem, index) => {
                    let val =
                      optionsItem.options.length > index
                        ? optionsItem.options[index]
                        : {
                            topText: "",
                            text: "",
                            value: "",
                            backgroundImage: { src: "" }
                          };
                    let option = {
                      ...val,
                      defaultLanguageValue: listItem.defaultLanguageValue,
                      label: listItem.value,
                      apiParentLabel: item.lable.toLowerCase(),
                      image: listItem.path,
                      topText: comparisonString(val.text, listItem.value) ? "" : listItem.value,
                      value: listItem.value
                    };
                    return option;
                  });

                  optionsItem.options = itemOptions;
                  const keyPropAll = Object.keys(query);
                  keyPropAll.forEach(key => {
                    let urlResult = itemOptions.filter(item => {
                      return item.apiParentLabel === key && item.value === query[key];
                    });
                    optionsItem.preselectedIndex = urlResult.length ? urlResult[0] : optionsItem.preselectedIndex;
                  });
                }
              });
            });
            if (memberOptionsItem.label === "MEMBERSHIP04" && !siteHaveFinance && apiHaveFinance && apiCash) {
              setLocalCash({
                apiParentLabel: apiCash.apiParentLabel,
                value: apiCash.value
              });
            }
            memberOptionsItem.carConfigItems = optionConfigItems;
          }
        });
      });
      membership.apiList = true;
      setMembership({ ...membership });
    }
    if (urlHashMember || membership.preselectedIndex >= 0) {
      let option = membership.options[membership.preselectedIndex];
      if (!unloadStatus) {
        await changeSummary(option);
      }
    }
  };
  const changeSummary = option => {
    let optionConfigItems = option?.carConfigItems ? option.carConfigItems : [],
      length = optionConfigItems.length,
      optionsValue = Number(option.value),
      body = {
        spuId: optionsValue
      };
    if (!option.hasOwnProperty("carConfigItems")) {
      return;
    }
    setShopspuId(optionsValue);
    if (length) {
      setFollowUpQuestions(option.carConfigItems);
      setSelectedColor(null);
      setSelectedEngine(null);
      setSelectedFinancing(null);
      option.carConfigItems.forEach((item, index) => {
        let levelcode = item.code ? item.code : "";

        switch (levelcode.toLowerCase()) {
          case "color":
            if (item.hasConfigPreSelectedIndex !== null && item.hasConfigPreSelectedIndex >= 0) {
              setSelectedColor(item.options[item.hasConfigPreSelectedIndex]);
            }
            if (item.preselectedIndex?.apiParentLabel) {
              setSelectedColor(item.preselectedIndex);
            }
            setColor({
              ...color,
              options: item.options
            });
            break;
          case "engine":
            if (item.hasConfigPreSelectedIndex !== null && item.hasConfigPreSelectedIndex >= 0) {
              setSelectedEngine(item.options[item.hasConfigPreSelectedIndex]);
            }
            if (item.preselectedIndex?.apiParentLabel) {
              setSelectedEngine(item.preselectedIndex);
            }
            setEngine({
              ...engine,
              options: item.options
            });
            break;
          case "finance":
            if (item.hasConfigPreSelectedIndex !== null && item.hasConfigPreSelectedIndex >= 0) {
              setSelectedFinancing(item.options[item.hasConfigPreSelectedIndex]);
            }
            if (item.preselectedIndex?.apiParentLabel) {
              setSelectedFinancing(item.preselectedIndex);
            }
            setFinancing({
              ...financing,
              options: item.options
            });
            break;
          default:
            break;
        }
      });
      setSelectedState(!selectedState);
      setShowFollowUpQuestions(true);
      setShowSummary(false);
    } else {
      setShowFollowUpQuestions(false);
      setShowSummary(true);
      getdetail(body, option);
    }
  };

  const handleConfigItems = option => {
    let carConfigItems = option?.carConfigItems ? option.carConfigItems : [];
    let optionItems = carConfigItems.map((item, index) => {
      let accordion = {},
        itemOptions = [],
        configItem = {},
        children = [],
        preselectedIndexValue = null,
        { headingBody, headingType, body, loadMore, backgroundImage, code, preselectedIndex, options } = item.fields;
      if (loadMore) {
        let { closeheadingBody, closeheadingType, open, openheadingBody, openheadingType, options } = loadMore.fields;
        accordion = {
          heading: {
            html: closeheadingBody,
            type: closeheadingType || {
              type: { fields: { phrase: { value: "h2" } } }
            }
          },
          headingOpen: {
            html: openheadingBody,
            type: openheadingType || {
              type: { fields: { phrase: { value: "h2" } } }
            }
          },
          open: open.value || false
        };
        children = options;
      }
      if (options) {
        itemOptions = options.map((level, index) => {
          let { code, title, backgroundImage, scrollTo } = level.fields;
          let option = {
            topText: "",
            text: title.value,
            label: code?.fields?.phrase?.value || "",
            value: "",
            backgroundImage: backgroundImage.value.src ? backgroundImage.value : { src: "" },
            scrollToId: scrollTo?.id
          };
          return option;
        });
      }
      if (preselectedIndex) {
        preselectedIndexValue = options.findIndex(val => val.id === preselectedIndex.id);
      }

      configItem = {
        heading: {
          type: headingType ? headingType : { type: { fields: { phrase: { value: "h1" } } } },
          html: headingBody
        },
        body: body,
        backgroundImage: backgroundImage.value.src ? backgroundImage.value.src : "",
        preselectedIndex: preselectedIndexValue,
        hasConfigPreSelectedIndex: preselectedIndexValue,
        code: code?.fields?.phrase?.value || "",
        options: itemOptions,
        optionSelectedChanged: (option, index) => {
        },
        accordion: accordion,
        children: children,
        id: item.id
      };
      return configItem;
    });

    return optionItems;
  };

  const getList = async () => {
    const res = await api.memebership.list(null, null);
    if (!res.obj) return [];
    return res.obj;
  };

  const getdetail = async (body, item) => {
    api.product
      .detail(null, body)
      .then(res => {
        if (!res.obj) return null;
        if (res.obj?.skuIdsList?.length) {
          getPrices(res.obj.skuIdsList[0], item);
        }
      })
      .catch(err => {
        item.summaryData.info.error = item.summaryData.systemErrorMessageText?.value;
        setSelectedMembership(item);
        console.dir(err);
      });
  };

  const getPrices = async (val, option) => {
    //保持原数据的纯洁
    let index = membership.options.findIndex(optionitem => {
      return optionitem.label === urlHash;
    });
    let item = option ? JSON.parse(JSON.stringify(option)) : JSON.parse(JSON.stringify(membership.options[index]));
    let skuIdval = val ? val.toString() : "";
    let level = item.label ? item.label : "";

    level = level.trim();
    api.product.sku
      .get(
        {
          skuId: skuIdval
        },
        null
      )
      .then(res => {
        if (res.obj) {
          let currency = res.obj.currencySymbol || "";
          let price = res.obj.price || 0;
          let msrp = res.obj.msrp || 0;
          price = price ? MathUtils.priceFormat(price, lang) : "";
          let depositPrice = res.obj.price || 0;
          switch (level) {
            case "MEMBERSHIP01":
              if (res.obj.price === 0) {
                price = item.summaryData.preorderdepositValue;
              }
              break;
            case "MEMBERSHIP02":
              break;
            case "MEMBERSHIP03":
              if (item.label.toLowerCase() === calculationRoute.membership) {
                msrp = calculationRoute.price;
                // currency = "";
              }
              break;
            case "MEMBERSHIP04":
              break;
            default:
              break;
          }
          item.summaryData.summary.details.deposit.apiCurrency = currency;
          item.summaryData.summary.details.deposit.apiDeposit = depositPrice;
          item.summaryData.summary.details.apiPrice = {
            value: msrp
          };
          item.summaryData.summary.details.deposit.deposit.value = MathUtils.priceFormat(depositPrice, lang);
          item.summaryData.summary.details.price.value = MathUtils.priceFormat(msrp, lang);
        }
        if (res.code !== "1") {
          item.summaryData.info.error = item.summaryData.systemErrorMessageText?.value || "";
        }
        setSelectedMembership(item);
      })
      .catch(err => {
        item.summaryData.info.error = item.summaryData.systemErrorMessageText?.value || "";
        setSelectedMembership(item);
        console.dir(err);
      });
  };

  const onOptionUpdatedFromSummary = ({ color, engine }) => {
    setSelectedEngine(engine);
    setSelectedColor(color);
    setSelectedState(!selectedState);
  };

  const optionSelectedChangedInStep = (option, index) => {
    scrollToNext(option.scrollToId);
    let newUrl = option.label ? `${window.location.pathname}#${option.label}` : window.location.pathname;
    if (option.hasOwnProperty("carConfigItems")) {
      history.push(newUrl);
      changeSummary(option);
    }
    clearCalculationPrice();

    /** Measurements */
    if (option.label === "MEMBERSHIP01" || option.label === "MEMBERSHIP02" || option.label === "MEMBERSHIP03" || option.label === "MEMBERSHIP04") {
      let dataLayer = window.dataLayer || [];
      let _currency = "EUR";
      if (country === "se") {
        _currency = "SEK";
      }
      let _page = {
        type: page.fields.pageType,
        currency: _currency,
        country: lang
      };
      const membershipLevel = getMembershipLevel(option.label);

      dataLayer.push({
        event: "memberChoice",
        eventCategory: "membership",
        eventAction: "level chosen",
        eventLabel: membershipLevel,
        page: _page
      });
    }
  };
  const scrollToNext = id => {
    scrollToSmoothTryMultipleTimes(id);
  };

  const selectedOptionValue = (step, index, option, code) => {
    scrollToNext(option.scrollToId);
    let levelcode = code ? code.toLowerCase() : "";

    /** Measurements */
    let dataLayer = window.dataLayer || [];
    let _currency = "EUR";
    if (country === "se") {
      _currency = "SEK";
    }
    let _page = {
      type: page.fields.pageType,
      currency: _currency,
      country: lang
    };
    switch (levelcode) {
      case "color":
        setSelectedColor(option);

        /** Measurements */
        dataLayer.push({
          event: "colorChoice",
          eventCategory: "membership car configuration",
          eventAction: "color",
          eventLabel: option.label,
          page: _page
        });
        break;
      case "engine":
        setSelectedEngine(option);

        /** Measurements */
        dataLayer.push({
          event: "engineChoice",
          eventCategory: "membership car configuration",
          eventAction: "engine",
          eventLabel: option.label,
          page: _page
        });
        break;
      case "finance":
        setSelectedFinancing(option);

        /** Measurements */
        dataLayer.push({
          event: "financingChoice",
          eventCategory: "membership car configuration",
          eventAction: "help with financing'",
          eventLabel: option.label,
          page: _page
        });
        break;
      default:
        break;
    }
    setSelectedState(!selectedState);
  };

  const getBecomeAMemberSummary = () => {
    let item = JSON.parse(JSON.stringify(selectedMembership));
    let level = selectedMembership?.text || "";
    let levelCode = selectedMembership?.label || "";

    level = level.trim();
    let becomeAMemberSummary = {
      membership: level,
      membershipCode: levelCode,
      country: item.summaryData.summary.details.membership.country.value,
      engine: {
        ...engine,
        preSelectValue: selectedEngine
      },
      financing: {
        ...financing,
        preSelectValue: selectedFinancing
      },
      color: {
        ...color,
        preSelectValue: selectedColor
      },
      deposit: item.summaryData.summary.details.deposit.apiDeposit,
      currency: item.summaryData.summary.details.deposit.apiCurrency,
      price: item.summaryData.summary.details.apiPrice,
      formattedPrice: item.summaryData.summary.details.deposit.deposit.value,
      formattedMsrp: item.summaryData.summary.details.price.value,
      shopspuId: shopspuId,
      customerNumber: user?.customerNumber || ""
    };
    webStorage.clear(S_ORDER_ID);
    setBecomeAMemberSummary(becomeAMemberSummary);
  };

  const goNextStep = (url, loggedInUser) => {
    let loginUrl = url;
    if (!loginUrl) {
      loginUrl = selectedMembership?.summaryData.summary.details.login.preSalesLoginUrl.value ? selectedMembership.summaryData.summary.details.login.preSalesLoginUrl.value.href : "";
      let newUrl = selectedMembership?.summaryData.summary.details.login.nextPageUrl ? selectedMembership.summaryData.summary.details.login.nextPageUrl.value.href : "";

      if (loginUrl === "") {
        loginUrl = fields?.defaultRedirect?.value.href || "";
      }
      if (newUrl) {
        loginUrl = loginUrl ? `${loginUrl}?redirect=${encodeURIComponent(newUrl)}` : `/${langLower}`;
      } else {
        loginUrl = loginUrl ? `${loginUrl}` : `/${langLower}`;
      }
    }
    webStorage.clear("S_ORDER_ID");
    const localUser = user ? user : loggedInUser;
    if (localUser) {
      creatingClues(localUser, selectedMembership?.label, comparisonToolApiBody).then(res => {
        if (!isBizNull(res)) {
          clearComparisonToolApiBody();
        }
      });
      becomeAMemberSummary.customerNumber = localUser.customerNumber;
      const accountAddInfoBody = {
        customerNumber: localUser?.customerNumber,
        color: selectedColor?.defaultLanguageValue,
        engine: selectedEngine?.defaultLanguageValue
      };
      if (localUser.membershipCode !== selectedMembership.label && localUser.membershipCode === "MEMBERSHIP04") {
        setShowChangeMembershipModels({
          ...showModels,
          fromLevel3: true
        });
      } else if (localUser.membershipCode !== selectedMembership.label && selectedMembership.label === "MEMBERSHIP02") {
        getBecomeAMemberSummary();
        if (fields.mebershipModalChangeToLevel1 && fields.mebershipModalChangeToLevel1[0] && fields.mebershipModalChangeToLevel1[0].fields) {
          setShowChangeMembershipModels({
            ...showModels,
            level1: true,
            url: loginUrl
          });
        } else {
          accountAddInfo(accountAddInfoBody);
          history.push(loginUrl);
        }
      } else if (localUser.membershipCode !== selectedMembership.label && selectedMembership.label === "MEMBERSHIP03") {
        getBecomeAMemberSummary();
        if (fields.mebershipModalChangeToLevel2 && fields.mebershipModalChangeToLevel2[0] && fields.mebershipModalChangeToLevel2[0].fields) {
          setShowChangeMembershipModels({
            ...showModels,
            level2: true,
            url: loginUrl
          });
        } else {
          accountAddInfo(accountAddInfoBody);
          history.push(loginUrl);
        }
      } else if (localUser.membershipCode !== selectedMembership.label && selectedMembership.label === "MEMBERSHIP04") {
        getBecomeAMemberSummary();
        if (fields.mebershipModalChangeToLevel3 && fields.mebershipModalChangeToLevel3[0] && fields.mebershipModalChangeToLevel3[0].fields) {
          setShowChangeMembershipModels({
            ...showModels,
            level3: true,
            url: loginUrl
          });
        } else {
          accountAddInfo(accountAddInfoBody);
          history.push(loginUrl);
        }
      } else if (localUser.membershipCode === selectedMembership.label) {
        setShowChangeMembershipModels({
          ...showModels,
          levelSame: true
        });
      } else {
        accountAddInfo(accountAddInfoBody);
        getBecomeAMemberSummary();
        history.push(loginUrl);
      }
    } else {
      getBecomeAMemberSummary();
      history.push(loginUrl);
    }
  };

  return (
    <React.Fragment>
      {membership.apiList && (
        <BecomeAMember
          {...{
            ...membership,
            optionSelectedChanged: (option, index) => {
              optionSelectedChangedInStep(option, index);
            }
          }}
          id={membership.id}
        />
      )}
      {showFollowUpQuestions && (
        <React.Fragment>
          {followUpQuestions &&
            followUpQuestions.map((item, queindex) => {
              return (
                <BecomeAMember
                  id={item.id}
                  key={queindex}
                  {...{
                    ...item,
                    preselectedIndex: item.options?.findIndex(itoption => {
                      if (!canUseDOM()) return;
                      let objArr;
                      if (item?.preselectedIndex) {
                        objArr = Object.keys(item?.preselectedIndex);
                      }

                      let preselectedIndex = objArr?.length === 0 ? item.options[0] : item.preselectedIndex;
                      switch (item.code.toLowerCase()) {
                        case "color":
                          preselectedIndex = selectedColor || item.options[item.preselectedIndex];
                          break;
                        case "engine":
                          preselectedIndex = selectedEngine || item.options[item.preselectedIndex];
                          break;
                        case "finance":
                          preselectedIndex = selectedFinancing || item.options[item.preselectedIndex];
                          break;
                        default:
                          preselectedIndex = item.preselectedIndex || item.options[item.preselectedIndex];
                          break;
                      }
                      return JSON.stringify(itoption) === JSON.stringify(preselectedIndex);
                    }),
                    optionSelectedChanged: (option, index) => {
                      selectedOptionValue(queindex, index, option, item.code);
                      optionSelectedChangedInStep(option, index);
                    }
                  }}
                />
              );
            })}
        </React.Fragment>
      )}
      {(showSumamry || (selectedEngine && selectedColor /*&& selectedFinancing*/ && selectedMembership)) && (
        <BecomeAMemberSummary
          id={selectedMembership.summaryData.id}
          {...{
            hero: {
              backgroundImage: sharedSummaryData?.hero?.backgroundImage,
              heroHeadingType: selectedMembership?.summaryData?.hero?.heroHeadingType,
              heroHeadingBody: selectedMembership?.summaryData?.hero?.heroHeadingBody
            },
            info: {
              ...sharedSummaryData?.info,
              ...selectedMembership?.summaryData?.info,
              cta: {
                ...selectedMembership?.summaryData?.info?.cta,
                callback: () => {
                  getBecomeAMemberSummary();
                  goNextStep();
                }
              }
            },
            login: {
              showLoginForm: selectedMembership.summaryData.summary.details.login.showLoginForm,
              createAccountHeadingType: selectedMembership.summaryData.summary.details.login.createAccountHeadingType,
              createAccountHeadingBody: selectedMembership.summaryData.summary.details.login.createAccountHeadingBody,
              createAccountButton: selectedMembership.summaryData.summary.details.login.createAccountButton,
              loginForm: selectedMembership.summaryData.summary.details.login.loginForm,
              inStoreLoginForm: selectedMembership.summaryData.summary.details.login.inStoreLoginForm,
              loginSuccessRedirectUrl: selectedMembership.summaryData.summary.details.login.loginSuccessRedirectUrl,
              history: history,
              lang: selectedMembership.summaryData.summary.details.login.lang,
              user: user,
              preSalesLoginUrl: selectedMembership.summaryData.summary.details.login.preSalesLoginUrl,
              nextPageUrl: selectedMembership.summaryData.summary.details.login.nextPageUrl,
              redirectUrlAfterLogout: selectedMembership.summaryData.summary.details.login.redirectUrlAfterLogout,
              logoutButtonText: selectedMembership.summaryData.summary.details.login.logoutButtonText,
              cta: selectedMembership.summaryData.summary.details.login.cta,
              setSummary: () => getBecomeAMemberSummary(),
              goNextStep: (url, loggedInUser) => goNextStep(url, loggedInUser)
            },
            summary: {
              ...sharedSummaryData.summary,
              callback: ({ color, engine }) => {
                onOptionUpdatedFromSummary({ color, engine });
              },
              text: {
                heading: sharedSummaryData.summary.text.heading,
                body: selectedMembership.summaryData.summary.text.body
              },
              details: {
                ...sharedSummaryData.summary.details,
                membership: {
                  ...sharedSummaryData.summary.details.membership,
                  membership: {
                    label: sharedSummaryData.summary.details.membership.membership.label,
                    value: selectedMembership?.text || "",
                    code: selectedMembership?.label
                  }
                },
                selection: {
                  ...sharedSummaryData.summary.details.selection,
                  choices: {
                    color: {
                      label: sharedSummaryData.summary.details.selection.choices.color.label,
                      selected: selectedColor,
                      options: color.options
                    },
                    engine: {
                      label: sharedSummaryData.summary.details.selection.choices.engine.label,
                      selected: selectedEngine,
                      options: engine.options
                    }
                  }
                },
                deposit: {
                  ...sharedSummaryData.summary.details.deposit,
                  currency: selectedMembership.summaryData.summary.details.deposit.currency,
                  deposit: {
                    label: sharedSummaryData.summary.details.deposit.deposit.label,
                    value: selectedMembership.summaryData.summary.details.deposit.deposit.value
                  },
                  disclaimer: selectedMembership.summaryData.summary.details.deposit.disclaimer
                },
                price: selectedMembership.summaryData.summary.details.price
              },
              showCarSelection: showFollowUpQuestions && selectedEngine != null && selectedColor != null
            },
            match,
            lang
          }}
        />
      )}
      {showModels.level1 && (
        <MembershipModal
          {...{
            ...fields.mebershipModalChangeToLevel1[0].fields,
            lang: langLower,
            history: history,
            selectedLevel: {
              value: selectedMembership.label
            },
            link: {
              value: {
                href: showModels.url
              }
            },
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                level1: false
              });
            }
          }}
        />
      )}
      {showModels.level2 && (
        <MembershipModal
          {...{
            ...fields.mebershipModalChangeToLevel2[0].fields,
            lang: langLower,
            history: history,
            selectedLevel: {
              value: selectedMembership.label
            },
            link: {
              value: {
                href: showModels.url
              }
            },
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                level2: false
              });
            }
          }}
        />
      )}
      {showModels.level3 && (
        <MembershipModal
          {...{
            ...fields.mebershipModalChangeToLevel3[0].fields,
            lang: langLower,
            history: history,
            becomeAMemberChangelevel: true,
            selectedLevel: {
              value: selectedMembership.label
            },
            link: {
              value: {
                href: showModels.url
              }
            },
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                level3: false
              });
            }
          }}
        />
      )}
      {showModels.fromLevel3 && (
        <MembershipModal
          {...{
            ...fields.mebershipModalChangeFromLevel3[0].fields,
            lang: langLower,
            history: history,
            selectedLevel: {
              value: user?.membershipCode
            },
            link: fields.mebershipModalChangeFromLevel3[0].fields.link,
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                fromLevel3: false
              });
            }
          }}
        />
      )}
      {showModels.levelSame && (
        <MembershipModal
          {...{
            ...fields.mebershipModalChangeToSameLevel[0].fields,
            lang: langLower,
            history: history,
            skipSubmit: true,
            selectedLevel: {
              value: selectedMembership.label
            },
            link: fields.mebershipModalChangeToSameLevel[0].fields.link,
            onCloseClicked: () => {
              setShowChangeMembershipModels({
                ...showModels,
                levelSame: false
              });
            }
          }}
        />
      )}
    </React.Fragment>
  );
};

BecomeAMemberFlow.propTypes = {
  membership: PropTypes.object,
  engine: PropTypes.object,
  color: PropTypes.object,
  financing: PropTypes.object,
  sharedSummaryData: PropTypes.object
};
const mapStateToProps = state => ({
  user: selectUserState(state),
  calculationPrice: state.calculationPrice,
  showModels: state.showChangeMembershipModels,
  comparisonToolApiBody: selectComparisonToolApiBody(state)
});
const mapDispatchToProps = dispatch => ({
  setBecomeAMemberSummary: data => {
    dispatch(becomeAMemberSummary(data));
  },
  clearCalculationPrice: data => {
    dispatch(clearCalculationPrice(data));
  },
  setShowChangeMembershipModels: data => {
    dispatch(setShowChangeMembershipModels(data));
  },
  clearComparisonToolApiBody: data => {
    dispatch(clearComparisonToolApiBody(data));
  }
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BecomeAMemberFlow));
